import { createVanIconComponent } from "./van"

const CouponOutlined = createVanIconComponent("coupon-o")
export default CouponOutlined
